import React from "react";
import { InteractiveContainer, PlainButton } from "@jugl-web/ui-components";
import { getFileSizeLabel } from "@jugl-web/utils/utils/files";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";
import { ReactComponent as PdfIcon } from "./assets/pdf.svg";
import { ReactComponent as DocxIcon } from "./assets/docx.svg";

export const FileItem: React.FC<{
  type: "pdf" | "docx";
  title: string;
  size: number | null;
  onClick: () => void;
  onDelete?: () => void;
}> = ({ size, title, type, onDelete, onClick }) => (
  <InteractiveContainer
    className="flex items-center justify-between gap-2.5 rounded-[10px] border border-solid border-grey-400 p-5"
    onClick={onClick}
  >
    <div className="flex items-center gap-2.5">
      <div className="flex items-center justify-center px-[5px]">
        {type === "pdf" ? <PdfIcon /> : <DocxIcon />}
      </div>
      <div className="flex flex-col gap-1">
        <span className="font-secondary leading-4 font-semibold text-dark">
          {title}
        </span>
        {typeof size === "number" && (
          <span className="font-secondary text-sm text-dark-700">
            {getFileSizeLabel(size)}
          </span>
        )}
      </div>
    </div>
    {onDelete && (
      <PlainButton
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <TrashIcon />
      </PlainButton>
    )}
  </InteractiveContainer>
);
